import React from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { Column } from 'primereact/column'
import MainCommonView from '../../../../components/common/MainCommonView'
import useHandlerBasicActions from '../../../../utils/hooks/useHandlerBasicActions'
import { MarginService } from '../../../../services/purchase-fuel/margin/margin.service'
import DataTableComp from '../../../../components/common/data-table/DataTableComp'
import { bodyParseDate } from '../../../../components/common/data-table/column-types/ColumnTypes'

const OwnFuelStationMargin = () => {
  const { formatMessage: msg } = useIntl()
  const { id } = useParams()

  const getMarginsByOwnStation = async ({ filter, sort, limit, skip }) =>
    MarginService.getAllByOwnSttion({ id, filter, sort, limit, skip })

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'purchaseMade',
    sortInit: -1,
    getAll: getMarginsByOwnStation,
  })

  const headerOptions = {
    title: msg({ id: 'margins' }),
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      tableOptions={{
        className: 'table-with-menu',
        size: 'small',
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column
          field="createdAt                    "
          header={msg({ id: 'purchase.date' })}
          body={(rowData) => bodyParseDate({ date: rowData?.createdAt })}
          sortable
        />,
        <Column
          field="GOA.margin"
          header={msg({ id: 'margin.GOA' })}
          sortable
        />,
        <Column
          field="GOA.percentage"
          header={msg({ id: 'percentage.GOA' })}
          sortable
        />,
        <Column
          field="G95.margin"
          header={msg({ id: 'margin.G95' })}
          sortable
        />,
        <Column
          field="G95.percentage"
          header={msg({ id: 'percentage.G95' })}
          sortable
        />,
      ]}
    />
  )

  return (
    <MainCommonView
      headerOptions={headerOptions}
      componentData={dataTable}
      pagerOptions={pagerOptions}
    />
  )
}

export default OwnFuelStationMargin
